import { Heading } from 'components/shared/Heading';
import { Texts } from 'components/shared/Texts';
import { FC } from 'react';
import { PretestStrings } from 'utils/strings';
import styles from './PretestSummary.module.scss';
import { getInterval } from './getInterval';
import React from 'react';
import { TextWithUrl, TextsProps } from 'components/shared/Texts/textWithUrl';
import { Button } from 'components/shared/Button';

interface PretestSummaryProps {
  routeTo: () => void;
  pretestResult: number;
}

export const PretestSummary: FC<PretestSummaryProps> = ({
  routeTo,
  pretestResult,
}) => {
  const summaryVariant = getInterval(pretestResult);
  const summaryDesc = PretestStrings().Summary.desc_result[summaryVariant];

  return (
    <section className={styles.pretest_summary}>
      <Heading type="h1" className={styles.summary_header}>
        {PretestStrings().Summary.header}
      </Heading>
      <div className={styles.summary_desc}>
        <div aria-hidden={true} className={styles.img_wrapper}>
          <img className={styles.logo} src="/motylek.png" alt="" />
        </div>

        <div className={styles.desc}>
          <Heading type="h2" className={styles.desc_header}>
            {summaryDesc.descHeader}
          </Heading>
          {summaryDesc.desc.map((text, i) => {
            if (text.str) {
              return text.str.map((desc, index) => (
                <Texts
                  key={`SummaryDesc_${i} DescTexts${index}`}
                  className={styles.desc_text}
                >
                  {desc}
                </Texts>
              ));
            } else {
              return (
                <TextWithUrl
                  key={`SummaryDesc_${i}`}
                  texts={text.link as TextsProps[]}
                  className={styles.desc_text}
                  classNameUrl={styles.desc_link}
                />
              );
            }
          })}
        </div>
      </div>
      <Button className={styles.nextPageNavigation} onClick={() => routeTo()}>
        {PretestStrings().Summary.buttonText}
      </Button>
    </section>
  );
};
